import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BadgeCheck, Star } from "lucide-react";

export default function Designers() {
  const [designers, setDesigners] = useState([]);
  useEffect(() => {
    api.get("/designers").then((r) => setDesigners(r.data));
  }, []);
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10">
      <h1 className="font-display font-bold text-3xl">Verified CAD Designers</h1>
      <p className="text-muted-foreground mt-1">Professional jewellery CAD studios and independent designers.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {designers.map((d) => (
          <Link key={d.id} to={`/designer/${d.id}`} data-testid={`designer-${d.id}`} className="border border-border rounded-md p-6 bg-card hover:border-primary hover:-translate-y-1 transition-all">
            <div className="flex items-center gap-4">
              <div className="h-14 w-14 rounded-full bg-primary/15 text-primary flex items-center justify-center font-display font-bold text-2xl">{d.name?.[0]}</div>
              <div>
                <p className="font-display font-semibold flex items-center gap-1">{d.name} {d.verified && <BadgeCheck className="h-4 w-4 text-primary" />}</p>
                <p className="font-mono text-xs text-muted-foreground flex items-center gap-1"><Star className="h-3 w-3 fill-amber-500 text-amber-500" /> {d.rating || "—"} · {d.rating_count} reviews</p>
              </div>
            </div>
            {d.bio && <p className="text-sm text-muted-foreground mt-4 line-clamp-2">{d.bio}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
